import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { SaaSDestination } from "../destinations/destinations";
import { LoadedDestinationInfo } from "../types/global";
import { HIPAAModeTooltip } from "../components/HIPAAModeTooltip";
import { CopyHelper } from "./CopyHelper";

const useStyles = makeStyles((theme) => ({
  titleWrapper: {
    display: "flex",
    alignItems: "center",
  },
  headerIcon: {
    marginRight: theme.spacing(2),
  },
}));

export const DestinationCardTitle: React.FC<{
  titleSuffix: string;
  destination: SaaSDestination | any;
  configuredDest: LoadedDestinationInfo | any;
}> = ({ titleSuffix, destination, configuredDest }) => {
  const classes = useStyles();
  const DestinationIcon = destination.logoSquare;
  const showSubtitle =
    destination?.supportsMultiConfig && configuredDest?.instance_name;
  const iconSize = showSubtitle ? 34 : 24;
  return (
    <div className={classes.titleWrapper}>
      <DestinationIcon
        className={classes.headerIcon}
        height={iconSize}
        width={iconSize}
      />
      <div>
        <div>
          {`${destination.name}: ${titleSuffix}`}
          <HIPAAModeTooltip dest={configuredDest} />
        </div>
        {(showSubtitle && (
          <CopyHelper
            labelText={`${destination.multiConfigLabel}: ${configuredDest.instance_name}`}
            copyText={`${destination.key}::${configuredDest.instance_name}`}
            tooltipText={"Copy integrations object identifier to clipboard"}
          />
        )) || (
          <CopyHelper
            labelText={`Integrations object identifier: ${destination.key}`}
            copyText={destination.key}
            tooltipText={"Copy integrations object identifier to clipboard"}
          />
        )}
        <CopyHelper
          labelText={`Consent object identifier: ${destination.key}`}
          copyText={destination.key}
          tooltipText={"Copy consent object identifier to clipboard"}
        />
      </div>
    </div>
  );
};
